(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[760],{

/***/ 322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes/[slug]",
      function () {
        return __webpack_require__(8043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ../../packages/viteui-lib/src/utils/datetime.ts
var datetime = __webpack_require__(5589);
// EXTERNAL MODULE: ../../packages/viteui-lib/src/packages/viteui-lib/src/components/TableOfContents/TableOfContents.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"../../packages/viteui-lib/src/components/TableOfContents/TableOfContents.css.ts.vanilla.css","source":"Ll8xanh2eXJuMCB7CiAgcGFkZGluZy10b3A6IC41cmVtOwp9CmxpID4gLl8xanh2eXJuMCB7CiAgbWFyZ2luLWxlZnQ6IDFyZW07CiAgZm9udC1zaXplOiAuNzVyZW07Cn0="}!../../node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(9971);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/TableOfContents/TableOfContents.css.ts

var list = '_1jxvyrn0';
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/TableOfContents/TableOfContents.tsx


var TOC_TITLE_TEXT = "On This Page";
var TableOfContents = function(param) {
    var _data = param.data, data = _data === void 0 ? [] : _data, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? true : _isOpen;
    if (!data.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("details", {
        "aria-labelledby": "label-toc-sum",
        className: "",
        open: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("summary", {
                className: "text-xs font-bold py-2 cursor-pointer",
                id: "label-toc-sum",
                children: TOC_TITLE_TEXT
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-2 border-t border-dotted border-current",
                children: renderLinks(data)
            })
        ]
    });
};
var renderLinks = function(data) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        className: "".concat(list, " space-y-2"),
        children: data.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "hover:text-e-color-onSurface focus:text-e-color-onSurface",
                        href: item.href,
                        children: item.text
                    }),
                    item.childLinks.length ? renderLinks(item.childLinks) : null
                ]
            }, item.href);
        })
    });
};

// EXTERNAL MODULE: ../../packages/viteui-lib/src/components/TitleBar/TitleBarScrollObsOuter.tsx + 1 modules
var TitleBarScrollObsOuter = __webpack_require__(3404);
// EXTERNAL MODULE: ../../packages/viteui-lib/src/packages/viteui-lib/src/components/EntryDetail/EntryDetail.css.ts.vanilla.css!=!../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{"fileName":"../../packages/viteui-lib/src/components/EntryDetail/EntryDetail.css.ts.vanilla.css","source":"#H4sIAAAAAAAAA41TXW+DIBR976+4L0vqMpxo7QdNlv2ThRaqpCIGqdos/e+z1E60NtuT3MPlHM656H/hpinYKYLvGQBCXYkJYM3l1sVCAmGHFZQxkScEKqrnfYM3rLG3nV1mflfFQ4VFz1YrzdBOc3okYD/oijg6yKhipLXw3P2dMkbJiZZefmnlEy0YMlwWGTUc7VV2knlJQIpc0mYevOGDHpxa/fsU4MjacQ1/wOvQ9Hoi1g0BejJqgNGHqFHGD2ZkcD3IQIskne6QVCcin2LYuPtTBIOGyZSp7agFM2lrLghe3Ah2fXxa1QTKguYQwnu3sNdXpTBC5QQ0b+MVFb8SfErOBIV5GzG6c8fRsmg8y3jnD2wFwETZzuZMrNTWQn/NbHGd2Wju9hxtn5ofd+lfHLGoE3N/iPs0XR+lEfvj+Ybahxv90gGk/JZym1SV3iBVcX3IVI3O/Ut4GCv2V/2dpvMJ18E4n/h5Pu08kPWKe9ofiQvW/g0EAAA="}!../../node_modules/@vanilla-extract/webpack-plugin/extracted/dist/vanilla-extract-webpack-plugin-extracted.cjs.js
var dist_vanilla_extract_webpack_plugin_extracted_cjs = __webpack_require__(2532);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/EntryDetail/EntryDetail.css.ts

var article = '_1xxpdu5';
var articleNoToc = '_1xxpdu6 _1xxpdu5';
var articleWithToc = '_1xxpdu7 _1xxpdu5';
var outer = '_1xxpdu0';
var related = '_1xxpdu3';
var tocContainer = '_1xxpdub';
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/EntryDetail/RelatedContent.tsx

var RelatedContent = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-sm font-semibold mb-8",
                children: "Links to this note"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "text-xs mb-4 grid sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-1 gap-x-8 gap-y-6",
                children: [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Est ex deserunt esse ut pariatur quis fugiat id velit commodo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2",
                                children: "Ut anim fugiat laboris et eiusmod aliquip."
                            })
                        ]
                    }, item);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/EntryDetail/EntryDetail.tsx






var SamplePostActions = function() {
    var handleSampleClick = function() {
        alert("clicked entry detail");
    }; // prettier-ignore
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex gap-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-10 h-10 flex items-center justify-center",
                onClick: handleSampleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "24",
                    height: "24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        xlinkHref: "/shared-assets/images/icons.svg#heart-outline"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "w-10 h-10 flex items-center justify-center",
                onClick: handleSampleClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "24",
                    height: "24",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        xlinkHref: "/shared-assets/images/icons.svg#share"
                    })
                })
            })
        ]
    });
};
var SampleByline = function(props) {
    var createdAt = props.createdAt, updatedAt = props.updatedAt, gardenStatus = props.gardenStatus;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "not-prose flex flex-col gap-x-4 gap-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-base",
                children: [
                    "By",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "text-e-color-onSurface font-bold border-b border-current hover:border-b-2 focus:border-b-2",
                        href: "/",
                        children: "Eka (@ekafyi)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-xs flex gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-e-color-onSurface/75",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                children: (0,datetime/* formatDate */.p)(createdAt)
                            }),
                            updatedAt && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "\xa0\xb7\xa0last updated ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                        children: (0,datetime/* formatDate */.p)(updatedAt)
                                    })
                                ]
                            })
                        ]
                    }),
                    gardenStatus && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "\uD83C\uDF31 ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: gardenStatus
                            }),
                            " (?)"
                        ]
                    })
                ]
            })
        ]
    });
};
var EntryDetail = function(param) {
    var data = param.data, _toc = param.toc, toc = _toc === void 0 ? [] : _toc, _children = param.children, children = _children === void 0 ? null : _children;
    var title = data.title, excerpt = data.excerpt, createdAt = data.createdAt, updatedAt = data.updatedAt, gardenStatus = data.gardenStatus;
    // TODO (later,perf) Lazy-load next/link for back button on visible.
    // Add ref={refBack} to leadingNode to detect visibility.
    // import { useInView } from "react-intersection-observer";
    // const { ref: refBack, inView: inViewBack } = useInView({ triggerOnce: true });
    var PROSE_CSS = "prose prose-sm md:prose-base prose-e";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBarScrollObsOuter/* default */.Z, {
                leadingNode: // !! update back button here
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-10 h-10 lg:hidden -ml-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "w-10 h-10 flex items-center justify-center",
                        href: "/notes",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "24",
                            height: "24",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                xlinkHref: "/shared-assets/images/icons.svg#arrow-left"
                            })
                        })
                    })
                }),
                trailingNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(SamplePostActions, {}),
                initialContentNode: null,
                scrolledContentNode: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "lg:text-sm font-semibold",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                id: "main",
                className: outer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: toc.length ? articleWithToc : articleNoToc,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                className: "".concat(PROSE_CSS, " space-y-5"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: title
                                    }),
                                    excerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "lead",
                                        children: excerpt
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SampleByline, {
                                        createdAt: createdAt,
                                        updatedAt: updatedAt,
                                        gardenStatus: gardenStatus
                                    })
                                ]
                            }),
                            !!toc.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(tocContainer, " ").concat(PROSE_CSS),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "not-prose xl:sticky xl:top-16 xl:max-h-screen xl:overflow-y-auto text-sm px-4 py-2 border border-e-color-onSurface xl:border-y-0 xl:border-r-0 xl:py-0 2xl:-ml-4 xl:border-e-color-outlineVariant",
                                    children: !!(toc === null || toc === void 0 ? void 0 : toc.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                        data: toc
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: PROSE_CSS,
                                children: children
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedContent, {
                            className: "".concat(related, " bg-e-color-surfaceVariant/40 text-e-color-onSurfaceVariant")
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/index.ts + 6 modules
var layouts = __webpack_require__(2930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(6670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(6297);
;// CONCATENATED MODULE: ../../packages/viteui-lib/src/components/Button/CopyButton.tsx





var CopyButton = function(props) {
    var copyState = props.copyState, elProps = (0,_object_without_properties/* default */.Z)(props, [
        "copyState"
    ]);
    var ref = (0,react.useState)(false), canCopy = ref[0], setCanCopy = ref[1];
    (0,react.useEffect)(function() {
        setCanCopy( true && "clipboard" in navigator && "writeText" in navigator.clipboard);
    }, []);
    return canCopy && copyState !== "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "absolute top-0 right-0"
    }, elProps), {
        children: copyState === "copied" ? "\u2705" : "copy"
    })) : null;
};
/* harmony default export */ var Button_CopyButton = (CopyButton);

// EXTERNAL MODULE: ../../node_modules/next-mdx-remote/dist/index.js + 2 modules
var dist = __webpack_require__(8724);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(7704);
// EXTERNAL MODULE: ../../node_modules/cloudinary-build-url/dist/esm/index.js
var esm = __webpack_require__(4329);
// EXTERNAL MODULE: ../../node_modules/cloudinary-build-url/dist/esm/url.js
var esm_url = __webpack_require__(7235);
;// CONCATENATED MODULE: ./src/lib/image.ts



var getUnsplashSrc = function(src, type) {
    var customProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var urlObj = new URL(src);
    if (type === "REGULAR") {
        var _w = customProps.w, w = _w === void 0 ? "1024" : _w, _q = customProps.q, q = _q === void 0 ? "60" : _q;
        // Mutate query parameters with supplied/default width & quality values.
        urlObj.searchParams.set("w", w);
        urlObj.searchParams.set("q", q);
        urlObj.searchParams.delete("h"); // Remove so it does not affect multi-size image proportions.
    } else if (type === "LQIP") {
        urlObj.searchParams.set("w", "20");
        urlObj.searchParams.set("q", "10");
    }
    return "".concat(urlObj.origin).concat(urlObj.pathname, "?").concat(urlObj.searchParams.toString());
};
/**
 * @link https://cloudinary.com/documentation/image_transformations#named_transformations
 */ var getCloudinaryNamedSrc = function(src, transformName) {
    var url = buildImageUrl(extractPublicId(src), {
        cloud: {
            cloudName: "ekalogs"
        },
        transformations: {
            transformation: transformName
        }
    });
    // example:
    // "res.cloudinary.com/ekalogs/image/upload/q_auto,t_named-w1080,f_auto/ekalogs-assets/geu26ckucx5zazkzygyc"
    return url.replace("q_auto,", "").replace(",f_auto", "");
};
/**
 * images.deviceSizes
 * TODO (later) import value from next.config directly
 */ var RESP_SIZES = [
    384,
    512,
    640,
    750,
    828,
    1080,
    1200
];
var getCloudinaryDynamicSrc = function(src, width) {
    var url = (0,esm/* buildImageUrl */.Sc)((0,esm_url/* extractPublicId */.A6)(src), {
        cloud: {
            cloudName: "ekalogs"
        },
        transformations: {
            quality: "auto:eco",
            resize: RESP_SIZES.includes(width) ? {
                type: "scale",
                width: width
            } : {}
        }
    });
    // example: "res.cloudinary.com/ekalogs/image/upload/c_scale,w_1080,q_auto:eco,f_auto/ekalogs-assets/geu26ckucx5zazkzygyc"
    var queryPath = url.split("image/upload/")[1].split("/")[0];
    var sortedQueryPath = queryPath.split(",").sort().join(",");
    return url.replace(queryPath, sortedQueryPath);
};
var lqipLoader = function(src) {
    // Currently only handling unsplash, everything else is rendered as-is
    if (src.includes("unsplash.com")) {
        return getUnsplashSrc(src, "LQIP");
    } else if (src.includes("res.cloudinary.com/ekalogs")) {
        return getCloudinaryNamedSrc(src, "lqip");
    }
    return src;
};
var customLoader = function(param) {
    var src = param.src, width = param.width;
    // Image quality is hardcoded to 60 (unsplash), auto:eco (cloudinary).
    // Add the "quality" prop to enable customizing from <Image>.
    if (src.includes("unsplash.com")) {
        return getUnsplashSrc(src, "REGULAR", {
            w: "".concat(width)
        });
    } else if (src.includes("res.cloudinary.com/ekalogs")) {
        return getCloudinaryDynamicSrc(src, width);
    }
    return src;
};
var markdownImageLoader = function(_param) {
    var width = _param.width, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "width"
    ]);
    var maxW = 1200; // No need to generate very large sizes beyond the Markdown container
    return customLoader((0,_object_spread/* default */.Z)({
        width: width <= maxW ? width : maxW
    }, restProps));
};


;// CONCATENATED MODULE: ./src/components/mdx/CustomImage.tsx








/**
 * @link https://tiborsaas.github.io/unique-gradient-generator
 * @link https://angrytools.com/gradient/image
 */ // "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAADCAYAAABfwxXFAAAAAXNSR0IArs4c6QAAAEtJREFUGFcVyNENgCAMQMFXIDVsRBwABzDsv4TGKNAa/i4nR2k+ZIA7WRSNG1d/WCd1b27BYDjJQIncPulMpJbTwRACjtDfD13OiR+KPx5hQ//1TQAAAABJRU5ErkJggg==";
var GRADIENT_B64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAWBJREFUOE+dlN9nxEAQx3f+oXKEEMJxhOM4Ksf9MX3rU59KKaWUUkqf+tSn/mM9u9TOj53Zvb00aRJWIjvznc98Z+GqvxmdC86F4OIaeJV3H04uXoFX5074b7xxn8/3wWp9iwFD8PQDbqwF5gCSOInghJ7WSsBLSjkgKoyPVa5KodncsUJRQEqldCpVkXhBwt9S6fwdVjFgjIUZbenTTIklKzVModncU1OKjDlTaUpFacEUmuFhzLqWuvqTlXrWfdsUwxTa4ZEYGk55l2tMYy5CVDKFZnhiH3LX2GeCQUuf51Not891Y08yvexTaLcvKaC1gPhMjS7Gn/YpdLvXMRstmZRFTLX70O7eJmcZlS7wKXT7d1RIpZ37Ldllpk+h23/8oZDKUb6SuO5T6K8/i1kujquFTDGgNXU5Efo+z6fQH75w9NTItPG/TCngnAAZx1iTTaynFKyP38XhUBp3GdNf2jxxOJ+YBPgAAAAASUVORK5CYII=";
var getWidthHeightFromParams = function(src) {
    var urlObj = new URL(src);
    var w = urlObj.searchParams.get("w");
    var h = urlObj.searchParams.get("h");
    if (w && h && !!parseInt(w) && !!parseInt(h)) {
        return {
            width: parseInt(w),
            height: parseInt(h)
        };
    } else {
        return;
    }
};
var MAX_W_PX = 650;
var CustomImage = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, imgProps = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    if (!src) return null;
    var wh = getWidthHeightFromParams(src);
    if (!wh) return /*#__PURE__*/ (0,jsx_runtime.jsx)(FallbackImage, (0,_object_spread/* default */.Z)({
        src: src,
        alt: alt
    }, imgProps));
    var layout = wh.width >= MAX_W_PX ? "responsive" : "intrinsic";
    var sizes = layout === "responsive" ? "(max-width: ".concat(MAX_W_PX, "px) 100vw, ").concat(MAX_W_PX, "px") : undefined;
    var priority = new URL(src).searchParams.get("priority") ? true : undefined;
    var Wrapper = layout === "responsive" ? "div" : react.Fragment;
    var wrapperProps = layout === "responsive" ? {
        style: {
            display: "block",
            width: "100%"
        }
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wrapperProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({
            alt: alt,
            blurDataURL: GRADIENT_B64,
            layout: layout,
            loader: markdownImageLoader,
            placeholder: "blur",
            priority: priority,
            sizes: sizes,
            src: src
        }, wh))
    }));
};
/* harmony default export */ var mdx_CustomImage = (CustomImage);
// -----
var FallbackImage = function(_param) {
    var src = _param.src, alt = _param.alt, imgProps = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react_intersection_observer_m/* useInView */.YD)({
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var fallbackSrc = GRADIENT_B64;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        alt: alt,
        loading: "lazy",
        ref: ref1,
        src: inView ? src : fallbackSrc,
        style: inView ? undefined : {
            minWidth: "16rem"
        }
    }, imgProps));
};

;// CONCATENATED MODULE: ./src/components/mdx/MDXRenderer.tsx








// import dynamic from "next/dynamic"; // https://nextjs.org/docs/advanced-features/dynamic-import
// const CopyButton = dynamic(() => import("@ekafyi/viteui-lib/components/Button/CopyButton"));
// import { lazy, Suspense } from "react"; // <Suspense><CopyButton /></Suspense>
// const CopyButton = lazy(() => import("@ekafyi/viteui-lib/components/Button/CopyButton"));
var getCalloutType = function(children) {
    if (Array.isArray(children) && children.length > 1) {
        var firstLine = "";
        if (typeof children[1].props.children === "string") {
            firstLine = children[1].props.children.split("\n")[0];
        } else if (Array.isArray(children[1].props.children)) {
            firstLine = children[1].props.children[0].split("\n")[0];
        }
        if (firstLine && firstLine.startsWith("[!") && firstLine.endsWith("]")) {
            return firstLine.replace("[!", "").replace("]", "").toLowerCase();
        }
    }
    return null;
};
var CustomA = function(_param) {
    var href = _param.href, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "href"
    ]);
    if (!href) return null;
    // External links.
    if (href.startsWith("https://")) {
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread/* default */.Z)({
            rel: "external",
            href: href
        }, restProps));
    }
    // Links to other (non-notes) parts of this site.
    if (href.split("/").length > 2) {
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread/* default */.Z)({
            href: href
        }, restProps));
    }
    var BASE_PATH = "notes";
    // TODO (later) handle HoverCard notes link
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread/* default */.Z)({
        href: "/".concat(BASE_PATH).concat(href)
    }, restProps));
};
var CustomBlockquote = function(props) {
    var calloutType = getCalloutType(props.children);
    if (calloutType) {
        var customProps = {
            "aria-label": calloutType,
            className: "not-prose"
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", (0,_object_spread/* default */.Z)({}, customProps, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", (0,_object_spread/* default */.Z)({}, props));
};
var CustomP = function(props) {
    var children = props.children, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var firstLine = "";
    if (typeof children === "string") {
        firstLine = children.split("\n")[0];
    } else if (Array.isArray(children) && typeof children[0] === "string") {
        firstLine = children[0].split("\n")[0];
    }
    if (firstLine && firstLine.startsWith("[!") && firstLine.endsWith("]")) {
        var calloutType = firstLine.replace("[!", "").replace("]", "").toLowerCase();
        var newProps = {};
        if (typeof children === "string") {
            newProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                children: children.replace("[!".concat(calloutType, "]\n"), "")
            });
        } else if (Array.isArray(children) && typeof children[0] === "string") {
            var newChildren = children.map(function(child, idx) {
                return idx === 0 ? children[0].replace("[!".concat(calloutType, "]\n"), "") : child;
            });
            newProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
                children: newChildren
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-callout-title": calloutType,
                    children: calloutType
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread/* default */.Z)({}, newProps))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread/* default */.Z)({}, props));
};
var CustomPre = function(props) {
    var preRef = (0,react.useRef)(null);
    var ref = (0,react.useState)("initial"), copyState = ref[0], setCopyState = ref[1];
    var handleCopy = function() {
        if (preRef && preRef.current) {
            try {
                navigator.clipboard.writeText(preRef.current.innerText);
                setCopyState("copied");
                setTimeout(function() {
                    setCopyState("initial");
                }, 2000); // prettier-ignore
            } catch (error) {
                setCopyState("error");
                console.error(error);
            }
        } else {
            console.warn("Cannot copy, element ref missing.");
        }
    };
    var Wrapper = props.hasOwnProperty("data-theme") ? react.Fragment : "div";
    var wrapperProps = props.hasOwnProperty("data-theme") ? {} : {
        "data-code-fragment": true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, wrapperProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_CopyButton, {
                onClick: handleCopy,
                copyState: copyState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", (0,_object_spread/* default */.Z)({
                ref: preRef
            }, props))
        ]
    }));
};
var components = {
    a: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomA, (0,_object_spread/* default */.Z)({}, props));
    },
    blockquote: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBlockquote, (0,_object_spread/* default */.Z)({}, props));
    },
    img: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(mdx_CustomImage, (0,_object_spread/* default */.Z)({}, props));
    },
    p: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomP, (0,_object_spread/* default */.Z)({}, props));
    },
    pre: function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPre, (0,_object_spread/* default */.Z)({}, props));
    }
};
var MDXRenderer = function(param) {
    var source = param.source;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), {
        components: components
    }));
};
/* harmony default export */ var mdx_MDXRenderer = (MDXRenderer);

;// CONCATENATED MODULE: ./src/components/mdx/index.ts


// EXTERNAL MODULE: ./src/components/PageSeo.tsx + 1 modules
var PageSeo = __webpack_require__(8144);
;// CONCATENATED MODULE: ./src/pages/notes/[slug].tsx






var MoteSinglePage = function(param) {
    var pageData = param.pageData, mdxSource = param.mdxSource, toc = param.toc;
    // Update html "lang" attribute for SEO & a11y.
    (0,react.useEffect)(function() {
        document.documentElement.setAttribute("lang", pageData.lang || "en");
    }, [
        pageData.lang
    ]);
    var seoData = {
        title: pageData.title,
        slug: pageData.slug,
        excerpt: pageData.excerpt || undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSeo/* NotesPageSeo */.vG, {
                activeData: seoData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryDetail, {
                data: pageData,
                toc: toc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mdx_MDXRenderer, {
                    source: mdxSource
                })
            })
        ]
    });
};
MoteSinglePage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* NoteSectionLayout */.x, {
        activeSlug: page.props.pageSlug,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (MoteSinglePage);


/***/ }),

/***/ 2532:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9971:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [133,120,655,774,888,179], function() { return __webpack_exec__(322); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);